const DB_NAME = 'shuttlr-offline-sessions';
const DB_VERSION = 1;
const STORE_NAME = 'sessions';

const memoryStore = new Map();

function canUseIndexedDb() {
  return typeof indexedDB !== 'undefined';
}

function openDb() {
  return new Promise((resolve, reject) => {
    const request = indexedDB.open(DB_NAME, DB_VERSION);
    request.onupgradeneeded = () => {
      const db = request.result;
      if (!db.objectStoreNames.contains(STORE_NAME)) {
        db.createObjectStore(STORE_NAME, { keyPath: 'sessionId' });
      }
    };
    request.onsuccess = () => resolve(request.result);
    request.onerror = () => reject(request.error);
  });
}

function emptyRecord(sessionId) {
  return {
    sessionId,
    snapshot: null,
    commands: [],
    blockedReason: null,
    blockedConflict: null,
    offlineMode: false,
    updatedAt: Date.now(),
  };
}

export async function loadOfflineSession(sessionId) {
  if (!sessionId) return emptyRecord(sessionId);
  if (!canUseIndexedDb()) {
    return memoryStore.get(sessionId) || emptyRecord(sessionId);
  }
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readonly');
    const request = tx.objectStore(STORE_NAME).get(sessionId);
    request.onsuccess = () => resolve(request.result || emptyRecord(sessionId));
    request.onerror = () => reject(request.error);
  });
}

export async function saveOfflineSession(record) {
  if (!record?.sessionId) return record;
  const next = { ...record, updatedAt: Date.now() };
  if (!canUseIndexedDb()) {
    memoryStore.set(record.sessionId, next);
    return next;
  }
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    tx.objectStore(STORE_NAME).put(next);
    tx.oncomplete = () => resolve(next);
    tx.onerror = () => reject(tx.error);
  });
}

export async function clearOfflineSession(sessionId) {
  if (!sessionId) return;
  if (!canUseIndexedDb()) {
    memoryStore.delete(sessionId);
    return;
  }
  const db = await openDb();
  return new Promise((resolve, reject) => {
    const tx = db.transaction(STORE_NAME, 'readwrite');
    tx.objectStore(STORE_NAME).delete(sessionId);
    tx.oncomplete = () => resolve();
    tx.onerror = () => reject(tx.error);
  });
}

export function __resetOfflineSessionMemoryForTests() {
  memoryStore.clear();
}
